
<script setup>
  import { ref, onBeforeMount, computed } from "vue";
  import useValidation from '@/utils/helpers/validations';
  import { useCompanyStore } from "@/stores/company";
  import { useUiStore } from "@/stores/ui";
  import { useDevicesStore } from "@/stores/devices";
  const emit = defineEmits(['refresh']);
  const uiStore = useUiStore();
  const devicesStore = useDevicesStore();

  const props = defineProps({
    appsOptions: Array,
  });

  // const global_user_name = inject(['global_user_name']);
  const user = ref(JSON.parse(localStorage.getItem("userDetails")));
  const { checkApkUrlValidation } = useValidation();

  let isSubmitted = ref(false);
  let name = ref(null);
  let devicesNames = ref([]);
  let mac_address = ref(null);
  let mac_addresses = ref([]);
  const company_id = useCompanyStore().companyId;
  let app = ref(null);
  let url = ref(null);
  let type = ref('apps_library');
  let isValidUrl = ref(true)
  const getModalInfo = computed(() => uiStore.modalData);
  const getModalAction = computed(() => uiStore.modalAction);

    const validUrl = () => {
      isValidUrl.value = true;
      if(url.value.length > 0){
        isValidUrl.value = checkApkUrlValidation(url.value);
        return isValidUrl.value;
      }

    };

  const onSubmit = () => {
    isSubmitted.value = true;
    let data = { 
      entityId: company_id,
      kioskName : devicesNames.value,
      macAddresses : mac_addresses.value,
      userName : user.value.first_name+' '+ user.value.last_name,
      userId : user.value.user_id,
      connectionType : 'daemon',
      key : type.value == 'apps_library'? app.value.url : url.value,
      downloadableFile : type.value == 'apps_library'? app.value.url : url.value,
    }

    devicesStore.massInstallApp(data)
    .then(() => {
      resetStoreData();
      emit('refresh');
    })
    .catch(() => {
      isSubmitted.value = false;
    });
  };

  const changeAppSourceVal = () => {
    app.value = null;
    url.value = null;
    isValidUrl.value = true;
  }

  const resetStoreData = () =>{
    uiStore.resetModalStore();
  };

  onBeforeMount(()=>{
    if(getModalInfo.value && getModalInfo.value.data_type == 'device' && getModalAction.value == 'install_app'){

      name.value = getModalInfo.value.name;
      mac_address.value = getModalInfo.value.mac_address;
      devicesNames.value.push(getModalInfo.value.name)
      mac_addresses.value.push(getModalInfo.value.mac_address)      
    }else if(getModalAction.value == 'mass_install_app') {
      if(Array.isArray(getModalInfo.value)){
        getModalInfo.value.map((row) =>{
          devicesNames.value.push(row.name)
          mac_addresses.value.push(row.mac_address)
        });
        name.value = devicesNames.value.join(", ");
      }
    }
  });

</script>

<template>
  <DModal v-if="['install_app', 'mass_install_app'].includes(getModalAction)" :visible="uiStore.modalState" @update:visible="val => { if (!val) resetStoreData() }" :main_classes="[]" :dialog_classes="[]">
    <template #title> Install App </template>

    <template #body>
      <div class="delete-text mb-3">
        <span>Select the application you want to  <b>"Install"</b> on the device "{{ name }}" ?</span>
      </div>

      <div class="flex unique-radio-inputs p-0 mb-3" >

        <div class="flex-1 radioOne p-0" >
          <input @change="changeAppSourceVal" class="form-check-input" type="radio" name="type" id="lamasaTechOption" value="apps_library" v-model="type" />
          <label class="form-check-label" for="lamasaTechOption">Apps Libarary</label>
          
        </div>

        <div class="flex-1 radioTwo p-0" >
          <input @change="changeAppSourceVal" class="form-check-input" type="radio" name="type" id="partnerOption" value="url" v-model="type"/>
          <label class="form-check-label" for="partnerOption">URL</label>
         
        </div>
       
      </div>

      <div v-if="type == 'apps_library'" class="relative">
        <FloatLabel class="w-full">
          <PDropdown v-model="app" input-id="install_app_select" :options="props.appsOptions"
            option-label="name" data-key="id" filter class="w-full" append-to="body"
          />
          <label for="install_app_select">Application</label>
        </FloatLabel>
      </div>

      
      <div v-else>
        <DInput :value="url" @input="(e) => { url = e.target.value; validUrl(); }" label="URL" width="100%" :class="{ 'is-invalid': !isValidUrl }" />
        <div v-if="!isValidUrl" class="invalid-feedback">
          Invalid URL.
        </div>
      </div>
      

    </template>

    <template #footer>
      <div class="w-full">
        <div class="seperator text-center"></div>
        <div class="flex mt-20 justify-center">
          <button :disabled="(!app && !url) || isSubmitted || !isValidUrl " 
          @click="onSubmit" type="button" class="btn btn-primary add-button mr-30">
            Install <span v-if="isSubmitted"  class="spinner-sm" role="status" aria-hidden="true" ></span>
          </button>
          <button @click="resetStoreData" type="button" class="btn btn-secondary cancel-button">Cancel</button>
        </div>
      </div>
    </template>
  </DModal>
</template>
